import { useEffect, useState } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";

// Soft glowing follower cursor. Expands and tints per doorway on hover.
export const CustomCursor = () => {
  const [enabled, setEnabled] = useState(false);
  const [variant, setVariant] = useState("default");
  const x = useMotionValue(-100);
  const y = useMotionValue(-100);
  const sx = useSpring(x, { stiffness: 400, damping: 40, mass: 0.4 });
  const sy = useSpring(y, { stiffness: 400, damping: 40, mass: 0.4 });

  useEffect(() => {
    const fine = window.matchMedia("(pointer: fine)").matches;
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (!fine || reduced) return;
    setEnabled(true);
    const move = (e) => {
      x.set(e.clientX);
      y.set(e.clientY);
      const el = e.target.closest?.("[data-cursor]");
      setVariant(el ? el.getAttribute("data-cursor") : "default");
    };
    window.addEventListener("mousemove", move);
    return () => window.removeEventListener("mousemove", move);
  }, [x, y]);

  if (!enabled) return null;
  const size = variant === "default" ? 12 : 60;
  const color =
    variant === "healing" ? "124,154,173" :
    variant === "rhythm" ? "158,120,200" :
    variant === "org" ? "233,180,76" : "245,245,245";

  return (
    <motion.div
      aria-hidden="true"
      className="pointer-events-none fixed left-0 top-0 z-[120] mix-blend-screen"
      style={{ x: sx, y: sy, translateX: "-50%", translateY: "-50%" }}
    >
      <motion.div
        animate={{
          width: size,
          height: size,
          backgroundColor: `rgba(${color},${variant === "default" ? 0.85 : 0.12})`,
          border: variant === "default" ? "0px solid transparent" : `1px solid rgba(${color},0.6)`,
        }}
        transition={{ type: "spring", stiffness: 300, damping: 25 }}
        className="rounded-full"
        style={{ boxShadow: `0 0 22px rgba(${color},0.45)` }}
      />
    </motion.div>
  );
};
